import { SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";

const FormConfig = {
    submit: {
        label: "Actualizar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "partidaArancelaria",
                        "label": "Partida Arancelarioa",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().min(12, "La partida arancelarioa debe tener al menos 12 caracteres"),
                    }
                ],
            ]
        }
    ],
};


export default FormConfig;